import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_RICH_PLACEMENT_MULTI_ANCHOR } from './api/query'
import { Data, Variables } from './api/types'
import { RichPlacementMultiAnchor, UseGetRichPlacementMultiAnchor } from './types'

export const useGetRichPlacementMultiAnchor = (): UseGetRichPlacementMultiAnchor => {
  const { workspaceId } = useWorkspaceParam()

  const { data, isLoading } = useQuery<Variables, Data, RichPlacementMultiAnchor>({
    options: {
      select: ({
        workspaceRichPlacementMultianchorConfiguration,
      }: Data): RichPlacementMultiAnchor => fromDTO(workspaceRichPlacementMultianchorConfiguration),
    },
    query: GET_RICH_PLACEMENT_MULTI_ANCHOR,
    variables: { workspaceId },
  })

  return { isLoading, multiAnchor: data }
}
